import React from 'react';
import { useWindowSize } from 'react-use';
import { Box, useTheme } from '@mui/material';

interface VerificationLayoutProps {
  children?: React.ReactNode;
}

export const VerificationLayout = ({ children = null }: VerificationLayoutProps) => {
  const { width } = useWindowSize();
  const theme = useTheme();

  return (
    <Box sx={width < theme.breakpoints.values.sm ? { paddingX: 2, paddingY: 3 } : { paddingX: 3, paddingY: 3 }}>
      {children}
    </Box>
  );
};
